import { useQuery } from 'react-query';
import TranslatorReport from '../../../models/TranslatorReport';

function useReportById(reportId?: string) {
    return useQuery<TranslatorReport>(['translatorreports/', reportId], { enabled: !!reportId });
}

export default useReportById;
